import React, { useEffect, FunctionComponent } from "react";
import ReactPannellum, { getConfig, setYaw } from "react-pannellum";
import { useTranslation } from "react-i18next";

interface IImage360Props {
  fileName: string;
  credits?: string;
}

function Image360(props:IImage360Props) {
  const { t } = useTranslation();
  const { fileName, credits } = props;

  const setNorth = () => {
    setYaw(0);
  }

  useEffect(() => {
    const elements = document.getElementsByClassName("pnlm-compass");
    const compass = elements.length ? elements[0] : null;
    if (compass !== null) {
      compass.addEventListener("click", setNorth);
      return () => {
        compass.removeEventListener("click", setNorth);
      }
    }
    return () => {};
  });

  const config = {
    // autoRotate: -2,
    autoRotate: 0,
    autoLoad: true,
    compass: false,
    showZoomCtrl: false,
    author: credits,
    uiText: {
      loadButtonLabel: t("360.btn_lbl"),
      loadingLabel: t("360.ldg_lbl"),
      bylineLabel: t("360.lin_lbl"),
      noPanoramaError: t("360.no_pan"),
      fileAccessError: t("360.fil_acs"),
      malformedURLError: t("360.mal_url")
    },
    showFullscreenCtrl: !document.fullscreen
  };

  return (
      <div>
        <ReactPannellum key={fileName} id={fileName} sceneId={fileName} imageSource={"/photos360/" + fileName} config={config} style={
          {
            width: "400px",
            height: "300px",
          }
        }/>
      </div>
  )
}

export default Image360;
